import { Box } from "@mui/material";

export const RightPaddingWrapper = ({ children }: any): any => {
  return (
    <Box
      sx={{
        p: {
          xl: "20px 0px 20px 80px",
          lg: "20px 0px 20px 80px",
          md: "",
          sm: "",
          xs: "16px 16px 16px 16px",
        },
        // backgroundColor: "rebeccapurple",
      }}
    >
      {children}
    </Box>
  );
};
